import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullLoaderComponent } from './full-loader.component';
import { DirectivesModule } from '../directives/directives.module';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [
    FullLoaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FullLoaderComponent,
    DirectivesModule,
    TranslationModule
  ]
})
export class FullLoaderModule { }
